import { StandardEvents } from '@shopify/events';

(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-sj-language]').forEach((select) => {
      if (select.dataset.sjInitialized) return;
      select.dataset.sjInitialized = 'true';
      const submit = select.form?.querySelector('[data-sj-language-submit]');
      if (submit) submit.hidden = true;
      select.addEventListener('change', () => select.form?.requestSubmit());
    });
    root.querySelectorAll('[data-sj-categories-toggle]').forEach((button) => {
      if (button.dataset.sjInitialized) return;
      button.dataset.sjInitialized = 'true';
      const section = button.closest('.sj-categories--home');
      if (!section) return;
      section.classList.add('sj-categories--collapsed');
      button.hidden = false;
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        section.classList.toggle('sj-categories--collapsed', !expanded);
        button.textContent = expanded ? button.dataset.hideLabel : button.dataset.showLabel + ' +';
      });
    });
  }
  initialize();
  // Horizon scrolls its page wrapper on desktop and the document on mobile.
  const backTop = document.createElement('button');
  backTop.type = 'button';
  backTop.className = 'sj-back-top';
  backTop.hidden = true;
  backTop.textContent = document.documentElement.lang.startsWith('id') ? '↑ Kembali ke atas' : '↑ Back to top';
  document.body.append(backTop);
  const scrollRoot = () => {
    const wrapper = document.querySelector('.page-wrapper');
    return wrapper && getComputedStyle(wrapper).overflowY === 'auto' ? wrapper : document.scrollingElement;
  };
  let scrollFrame = 0;
  const updateBackTop = () => {
    if (scrollFrame) return;
    scrollFrame = requestAnimationFrame(() => {
      backTop.hidden = (scrollRoot()?.scrollTop || 0) < window.innerHeight;
      scrollFrame = 0;
    });
  };
  document.addEventListener('scroll', updateBackTop, { capture: true, passive: true });
  window.addEventListener('resize', updateBackTop, { passive: true });
  window.addEventListener('pageshow', updateBackTop);
  window.addEventListener('pageshow', () => {
    const cardId = history.state?.sjReturnCard;
    if (!cardId) return;
    // Run after native scroll restoration, including bfcache returns.
    requestAnimationFrame(() => requestAnimationFrame(() => {
      document.getElementById(cardId)?.scrollIntoView({ block: 'start', behavior: 'instant' });
    }));
  });
  backTop.addEventListener('click', () => {
    const root = scrollRoot();
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    if (root === document.scrollingElement) window.scrollTo({ top: 0, behavior });
    else root?.scrollTo({ top: 0, behavior });
  });
  updateBackTop();
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('.sj-product-card__inquiry') : null;
    if (!link) return;
    const quantity = link.closest('.sj-card-action-row')?.querySelector('input[name="quantity"]');
    if (!(quantity instanceof HTMLInputElement) || !quantity.checkValidity()) return;
    link.dataset.sjInquiryUrl ||= link.href;
    const url = new URL(link.dataset.sjInquiryUrl);
    const label = document.documentElement.lang.startsWith('id') ? 'Jumlah' : 'Quantity';
    url.searchParams.set('text', (url.searchParams.get('text') || '') + `\n${label}: ${quantity.value}`);
    link.href = url.toString();
  });
  function setCartCount(count) {
    if (!Number.isInteger(count) || count < 0) return;
    document.querySelectorAll('[data-sj-cart-count]').forEach((badge) => { badge.textContent = String(count); });
  }
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    event.promise?.then(({ cart, detail }) => {
      setCartCount(cart?.totalQuantity ?? detail?.itemCount);
    }).catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[SJ header] Cart count could not be refreshed.');
    });
  });
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    const cartUrl = (window.Shopify?.routes?.root || '/') + 'cart.js';
    fetch(cartUrl, { headers: { Accept: 'application/json' } })
      .then((response) => response.ok ? response.json() : null)
      .then((cart) => { if (cart) setCartCount(cart.item_count); })
      .catch(() => {});
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-sj-menu][open]').forEach((details) => {
      details.open = false;
      details.querySelector('summary')?.focus();
    });
  });
})();


document.addEventListener('toggle', (event) => {
  const group = event.target;
  if (!(group instanceof HTMLDetailsElement) || !group.matches('[data-sj-nav-group]') || !group.open) return;
  group.closest('nav')?.querySelectorAll('[data-sj-nav-group][open]').forEach((other) => { if (other !== group) other.open = false; });
}, true);
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Node)) return;
  document.querySelectorAll('[data-sj-nav-group][open]').forEach((group) => { if (!group.contains(event.target)) group.open = false; });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
  const group = event.target.closest('nav')?.querySelector('[data-sj-nav-group][open]');
  if (!group) return;
  group.open = false;
  group.querySelector('summary')?.focus();
  event.preventDefault();
  event.stopImmediatePropagation();
}, true);
